// 🔐 accounts (09-30, ACCOUNTS_SIGNIN_SPEC_2026_09_30.md): the hidden switch.
// The SHOW_PORTED_PLACE pattern: an exported constant, test-pinned, so turning
// sign-in on for everyone is a deliberate two-file edit (this + its test).
// OFF: nobody sees a sign-in door and nothing here makes a network call.
// Nina previews it on ONE device: a browser holding the /admin key opens any
// page with ?signin=1 (remembered on that device; ?signin=0 forgets it).
export const SHOW_SIGN_IN = false;
export const SIGNIN_PREVIEW_KEY = 'sign_in_preview';

export function signInPreviewOn(win = (typeof window !== 'undefined' ? window : null)) {
  try {
    const ls = win && win.localStorage;
    if (!ls || !ls.getItem('adminApiKey')) return false;
    const q = new URLSearchParams(win.location.search).get('signin');
    if (q === '1') ls.setItem(SIGNIN_PREVIEW_KEY, '1');
    if (q === '0') ls.removeItem(SIGNIN_PREVIEW_KEY);
    return ls.getItem(SIGNIN_PREVIEW_KEY) === '1';
  } catch (e) { return false; }
}

export const signInOn = (win) => SHOW_SIGN_IN || signInPreviewOn(win);
